<template>
    <q-page class="col-12 col-md-8 col-lg-6 offset-lg-3 offset-md-2">
        <span class="text-h6 full-width text-center block" style="color:rgb(93 93 93);">Custom domain short links — free, forever.</span>
        <div class="icon-container" style="display: flex; justify-content: center;">
            <q-icon name="fa-solid fa-caret-down" style="color: #ff3922; font-size: 2em;"/>
        </div>
        <span class="text-body1 text-center  q-mb-md block text-blue bg-white">
            https://<span class="text-deep-orange">Your-Domain</span>.{{ appDomain }}/
            <span class="text-deep-orange">Your-Keyword</span>
        </span>

        <div v-if="!store.getters.isAuthenticated" class="row justify-center q-my-md">
            <q-btn color="primary"
                   href="https://www.linkedin.com/feed/update/urn:li:activity:7329453953023107072"
                   target="_blank"
                   icon="fa-brands fa-linkedin"
                   label="From LinkedIn: Why you need Memo.Link" no-caps/>
        </div>
        <CheckDomain v-if="!store.getters.isAuthenticated"/>
        <div class="q-mb-md q-pa-md" v-if="store.getters.isAuthenticated && store.getters.user.subDomainCount === 0">
            <AddSubdomain/>
        </div>
        <Create v-if="store.getters.isAuthenticated && store.getters.user.subDomainCount > 0"/>
        <Milestone/>
        <BottomText/>
    </q-page>
</template>

<script setup>
import Create from './MemoLink/Create.vue'
import CheckDomain from '../includes/CheckDomain.vue'

import { inject } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useQuasar } from 'quasar'
import Milestone from '../includes/Milestone.vue'
import BottomText from '../includes/BottomText.vue'
import AddSubdomain from '../includes/AddSubdomain.vue'

const router = useRouter()
const quasar = useQuasar()
const store = useStore()
const appDomain = inject('appDomain')

</script>

<style scoped>

</style>
